export { apiClient } from './config'
export { parseAttachmentFilename, toReadableDownloadError } from './attachment-response'

export type * from './types'
export { UserType, ORDER_STATUSES } from './types'

export { authService } from './services/auth'
export { authCodesService } from './services/authCodes'
export { aiQcService } from './services/aiQc'
export { eventLogsService } from './services/eventLogs'
export { gcpLogsService } from './services/gcpLogs'
export type { GcpLogEntry, GcpLogsQueryResponse } from './services/gcpLogs'
export { gdprService } from './services/gdpr'
export { ordersService } from './services/orders'
export { packageMappingsService } from './services/packageMappings'
export { profilesService } from './services/profiles'
export { purchaseReceiptsService } from './services/purchaseReceipts'
export type {
  PurchaseReceiptOrderStatus,
  SendPurchaseReceiptResult,
} from './services/purchaseReceipts'
export { settingsService } from './services/settings'
export { sendgridService } from './services/sendgrid'
export type { SendGridActivityMessage } from './services/sendgrid'
export { pipelineSlaService } from './services/pipelineSla'
export { unhealthyCustomersService } from './services/unhealthyCustomers'
export { usersService } from './services/users'
export type { ProfileResponse, ProfileWithValidationResponse, AIQuestion, AIQuestionsResponse, PatientProfileExportRecord } from './services/profiles'
export type { AppSettings, UpdateAppSettingsRequest } from './services/settings'
export type { PackageMappingsResponse } from './services/packageMappings'

export const handleApiError = (error: unknown): string => {
  if (error && typeof error === 'object' && 'response' in error) {
    const apiError = error as { response: { data?: { message?: string } } }
    return apiError.response?.data?.message || 'An unexpected error occurred'
  }

  if (error instanceof Error) {
    return error.message
  }

  return 'An unexpected error occurred'
}
